import PartnersCRUDActions from '../actions/PartnersCRUDActions';
import { setUnBusy } from './common/commonReducers';
import Actions from '../actions/actions';
import { PartnersState } from '../interfaces/partners';

const initialState: PartnersState = {
  token: null,
  busy: false,
  page: null,
};

export default function partners(state = initialState, action) {
  switch (action.type) {
    case PartnersCRUDActions.setTokenAction: {
      return {
        ...state,
        token: action.token,
        busy: false,
      };
    }
    case PartnersCRUDActions.setTokenPageAction: {
      return {
        ...state,
        busy: false,
        page: action.tokenPage,
      };
    }
    case Actions.RESET:
      return initialState;
    case Actions.UNBUSY:
      return setUnBusy(state);
    default:
      return state;
  }
}
